import {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import cn from 'classnames';
import {DownOutlined, GlobalOutlined, LogoutOutlined,} from '@ant-design/icons';
import {Avatar, Dropdown, Layout, MenuProps, Modal} from 'antd';
import {useTranslation} from 'react-i18next';
import {useAppStore} from '@/stores';
import i18n from '@/i18n';
import {ROUTES} from '@/models';
import Hamburger from '../Hamburger';
import LangDropDown from '../Language';
import styles from './index.module.scss';

const {Header} = Layout;

const returnItems = (handleLogout: () => void) => {
  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <a
          target='_blank'
          href='https://experiences.suplift.com'
          rel='noopener noreferrer'
        >
          <GlobalOutlined className={styles.userMenuIcon}/>
          {i18n.t('supliftWebsite')}
        </a>
      ),
    },
    {
      key: '2',
      label: (
        <>
          <LogoutOutlined className={styles.userMenuIcon}/> {i18n.t('logout')}
        </>
      ),
      onClick: handleLogout,
    },
  ];
  return items;
};

const LayoutHeader: FC = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {sidebarCollapsed, currentUser, logout} = useAppStore();
  // handle logout
  const handleLogout = () => {
    Modal.confirm({
      title: t('logout'),
      content: t('areYouSureToLogout'),
      okText: t('yes'),
      cancelText: t('cancel'),
      onOk: () => {
        logout(() => navigate(ROUTES.LOGIN));
      },
    });
  };

  return (
    <Header
      className={cn(styles.header, {
        [styles.headerLayoutColl]: sidebarCollapsed,
        [styles.headerLayoutNotColl]: !sidebarCollapsed,
      })}
    >
      <Hamburger/>
      <div className={styles.rightMenu}>
        <div className='dropdown-wrap'>
          <Dropdown menu={{items: returnItems(handleLogout)}}>
            <div className={styles.userWrap}>
              <Avatar
                shape='square'
                size={30}
                src={`${process.env.PUBLIC_URL}/assets/images/user.png`}
              />
              <span className={styles.userName}>
                {currentUser?.role && t(currentUser?.role)}
              </span>
              <DownOutlined/>
            </div>
          </Dropdown>
        </div>
        <LangDropDown/>
      </div>
    </Header>
  );
};

export default LayoutHeader;
